import { render, staticRenderFns } from "./EspondiloartritesAsasPhase.vue?vue&type=template&id=5d40f660&scoped=true&"
import script from "./EspondiloartritesAsasPhase.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesAsasPhase.vue?vue&type=script&lang=js&"
import style0 from "./EspondiloartritesAsasPhase.vue?vue&type=style&index=0&id=5d40f660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40f660",
  null
  
)

export default component.exports